import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys, resolveDirective as _resolveDirective } from "vue"
import _imports_0 from '@/assets/img/close.svg'


const _hoisted_1 = ["onKeyup"]
const _hoisted_2 = { class: "b-suggests-search__form-group border-radius" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  width: "24px",
  height: "24px",
  class: "icon",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z" })
], -1)
const _hoisted_4 = ["value", "placeholder"]
const _hoisted_5 = ["value", "placeholder"]
const _hoisted_6 = {
  key: 0,
  class: "b-suggests-search__results_list"
}
const _hoisted_7 = {
  key: 0,
  class: "flex col between-xs"
}
const _hoisted_8 = { class: "suggests-end flex middle-xs" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = {
  key: 1,
  class: "suggests-end flex middle-xs"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import {
    computed,
    nextTick,
    onBeforeUnmount,
    onMounted,
    PropType,
    ref,
    watch,
  } from 'vue';
  import { useStore } from 'vuex';
  import { useRoute } from 'vue-router';
  import debounce from 'lodash/debounce';
  import { Suggest } from 'types';
  import Emitter, { EVENT_NAMES } from '@/plugins/emitter';
  import SuggestComponent from './SuggestComponent.vue';
  import SpinnerComponent from './SpinnerComponent.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'SuggestsSearchComponent',
  props: {
    inputId: {
      type: String as PropType<Suggest.Ids>,
      required: true,
    },
    suggestType: {
      type: Number as PropType<Suggest.Type>,
      required: true,
    },
    defaultControls: {
      type: Boolean,
      default: true,
    },
    placeholder: String,
    isEmptyError: Boolean,
  },
  emits: ['onSuggest', 'removeEmptyError'],
  setup(__props, { emit }) {

const props = __props

  const route = useRoute();
  const store = useStore();

  

  

  const baseRef = ref<HTMLDivElement>();
  const suggestContainerRef = ref<HTMLDivElement>();
  const suggestRef = ref<Array<InstanceType<typeof SuggestComponent>>>();
  const searchInputRef = ref<HTMLInputElement>();
  const searchQueryRef = ref<HTMLInputElement>();

  const isSearchOpen = ref<boolean>(false);
  const hoveredIndex = ref<number>(null);
  const query = ref<Suggest.Query>({ text: '', type: Suggest.QueryType.AUTO });

  const onQueryChangedDebounced = debounce(onQueryChanged, 600);

  const suggests = computed<Suggest.Suggest<Suggest.TypedSuggest>[]>(() =>
    store.getters['suggest/getSuggests'](props.inputId),
  );
  const loading = computed<boolean>(() =>
    store.getters['suggest/loading'](props.inputId),
  );
  const suggestIsNotEmpty = computed<boolean>(() =>
    store.getters['suggest/suggestIsNotEmpty'](props.inputId),
  );
  const queryModel = computed<Suggest.Query>(() =>
    store.getters['suggest/getQuery'](props.inputId),
  );
  const suggest = computed<Suggest.Suggest<Suggest.TypedSuggest>>(() =>
    store.getters['suggest/getSuggest'](props.inputId),
  );

  function setLoading(loading: boolean) {
    store.commit('suggest/setLoading', { loading, id: props.inputId });
  }

  async function onQueryChanged() {
    store.dispatch('suggest/search', {
      query: query.value,
      id: props.inputId,
      type: props.suggestType,
    });
  }

  function openSearch() {
    isSearchOpen.value = true;

    nextTick(() => {
      if (searchQueryRef.value) {
        searchQueryRef.value.focus();
        searchQueryRef.value.select();
      }
    });
  }

  async function clearQuery() {
    await store.commit('suggest/clear', props.inputId);

    nextTick(() => {
      if (searchQueryRef.value) {
        searchQueryRef.value.focus();
        searchQueryRef.value.select();
      }
    });
  }

  function closeSearch(event, force?: boolean) {
    const path = event
      ? event.path || (event.composedPath && event.composedPath())
      : null;

    const isClickOutside = event
      ? path
        ? path.indexOf(baseRef.value) < 0
        : !baseRef.value.contains(event.target)
      : true;

    if (
      isClickOutside ||
      force ||
      (event && event.type != 'click' && event.type != 'focusout')
    ) {
      isSearchOpen.value = false;
      hoveredIndex.value = null;
      if (searchInputRef.value) {
        searchInputRef.value.blur();
      }
    }
  }

  function focusout(event: FocusEvent) {
    if (event.relatedTarget) {
      closeSearch(event);
    }
  }

  function selectDown() {
    if (!suggestContainerRef.value || !suggestRef.value) {
      return;
    }

    if (
      (hoveredIndex.value != null &&
        hoveredIndex.value >= suggests.value.length - 1) ||
      hoveredIndex.value === null
    ) {
      hoveredIndex.value = 0;
    } else {
      hoveredIndex.value++;
    }

    const container = suggestContainerRef.value;
    const elem = suggestRef.value[hoveredIndex.value].suggestRef;

    if (
      elem.offsetTop - elem.clientHeight >= container.scrollTop &&
      elem.offsetTop + elem.clientHeight <=
        container.scrollTop + container.clientHeight
    ) {
      return;
    }

    if (elem.offsetTop + elem.clientHeight > container.clientHeight) {
      container.scrollTop += elem.clientHeight;
    } else if (elem.offsetTop <= container.scrollTop) {
      container.scrollTop = elem.offsetTop - elem.clientHeight;
    }
  }

  function selectUp() {
    if (!suggestContainerRef.value || !suggestRef.value) {
      return;
    }

    if (hoveredIndex.value) {
      hoveredIndex.value--;
    } else {
      hoveredIndex.value = suggests.value.length - 1;
    }

    const container = suggestContainerRef.value;
    const elem = suggestRef.value[hoveredIndex.value].suggestRef;

    if (
      elem.offsetTop - elem.clientHeight >= container.scrollTop &&
      elem.offsetTop + elem.clientHeight <=
        container.scrollTop + container.clientHeight
    ) {
      return;
    }

    if (elem.offsetTop <= container.scrollTop) {
      container.scrollTop -= elem.clientHeight;
    } else if (elem.offsetTop > container.scrollTop) {
      container.scrollTop = elem.offsetTop - elem.clientHeight;
    }
  }

  function selectSuggest($event?: Suggest.Suggest<Suggest.TypedSuggest>) {
    if (hoveredIndex.value != null) {
      const suggest: Suggest.Suggest<Suggest.TypedSuggest> = $event
        ? $event
        : suggests.value[hoveredIndex.value];

      const selectedSuggestsPayload: Suggest.SelectedSuggest = {
        suggest: suggest,
        inputId: props.inputId,
        hoveredIndex: hoveredIndex.value,
      };

      emit('onSuggest', selectedSuggestsPayload);

      nextTick(() => {
        closeSearch(null, true);
        (document.activeElement as HTMLElement).blur();
      });
    }
  }

  function shakeInputOnError() {
    if (searchInputRef.value && props.isEmptyError) {
      searchInputRef.value.classList.add('shake');
      setTimeout(() => {
        searchInputRef.value.classList.remove('shake');
      }, 1000);
    }
  }

  onMounted(() => {
    query.value = {
      text: queryModel.value.text,
      type: queryModel.value.type,
    };

    Emitter.$on(EVENT_NAMES.SUGGEST_ERROR, shakeInputOnError);
  });

  onBeforeUnmount(() => {
    Emitter.$off(EVENT_NAMES.SUGGEST_ERROR, shakeInputOnError);
  });

  watch(
    queryModel,
    val => {
      if (val) {
        query.value = {
          text: decodeURIComponent(val.text),
          type: val.type,
        };
      }
    },
    { deep: true },
  );

  watch(
    query,
    val => {
      if (val && val.text && val.text.length > 2) {
        setLoading(true);
        onQueryChangedDebounced();
        emit('removeEmptyError');
      } else {
        setLoading(false);
      }
    },
    { deep: true },
  );

  watch(route, (val, oldVal) => {
    if (val.name != oldVal.name && val.name === 'search') {
      emit('removeEmptyError');
    }
  });

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    ref_key: "baseRef",
    ref: baseRef,
    class: "b-suggests-search",
    onFocusout: focusout,
    onKeyup: [
      _withKeys(closeSearch, ["esc"]),
      _withKeys(selectDown, ["down"]),
      _withKeys(selectUp, ["up"])
    ]
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["b-suggests-search__container", [{ active: isSearchOpen.value }, { error: __props.isEmptyError }]])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("input", {
          ref_key: "searchInputRef",
          ref: searchInputRef,
          class: "regular black",
          type: "text",
          value: _unref(suggest) ? _unref(suggest).title : '',
          placeholder: __props.placeholder,
          readonly: true,
          onFocus: openSearch,
          autocomplete: "off",
          autocorrect: "off",
          autocapitalize: "off",
          spellcheck: false
        }, null, 40, _hoisted_4),
        (!__props.defaultControls)
          ? _renderSlot(_ctx.$slots, "default", { key: 0 })
          : _createCommentVNode("", true)
      ]),
      _withDirectives(_createElementVNode("div", {
        class: "b-suggests-search__results border-radius",
        ref_key: "suggestContainerRef",
        ref: suggestContainerRef
      }, [
        _createElementVNode("form", {
          class: "b-suggests-search__results_q",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (selectSuggest(null)), ["prevent","stop"]))
        }, [
          _createElementVNode("input", {
            ref_key: "searchQueryRef",
            ref: searchQueryRef,
            class: _normalizeClass(["regular black", { empty: !query.value || query.value?.text?.length === 0 }]),
            type: "text",
            value: query.value.text,
            onInput: _cache[0] || (_cache[0] = ($event: any) => (query.value.text = ($event.target as HTMLInputElement).value)),
            placeholder: __props.placeholder,
            autocomplete: "off",
            autocorrect: "off",
            autocapitalize: "off",
            spellcheck: false
          }, null, 42, _hoisted_5),
          (_unref(loading))
            ? (_openBlock(), _createBlock(SpinnerComponent, {
                key: 0,
                class: "b-suggests-search__loading"
              }))
            : (query.value.text.length > 0)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  class: "close-icon",
                  width: "24",
                  height: "24",
                  role: "button",
                  src: _imports_0,
                  alt: "",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (clearQuery()), ["stop"]))
                }))
              : _createCommentVNode("", true)
        ], 32),
        (query.value.text.length > 2 && !_unref(loading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_unref(suggestIsNotEmpty))
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(suggests), (suggest, i) => {
                        return (_openBlock(), _createBlock(SuggestComponent, {
                          ref_for: true,
                          ref_key: "suggestRef",
                          ref: suggestRef,
                          class: _normalizeClass({ active: i === hoveredIndex.value }),
                          key: i,
                          suggest: suggest,
                          onAction: selectSuggest,
                          onMouseover: ($event: any) => (hoveredIndex.value = i)
                        }, null, 8, ["class", "suggest", "onMouseover"]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_i18n_t, {
                        keypath: "searchForm.suggestsHelpInfo",
                        tag: "p",
                        class: "regular grey",
                        scope: "global"
                      }, {
                        break: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : (query.value.text.length >= 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_i18n_t, {
                        keypath: "searchForm.suggestsHelpInfo",
                        tag: "p",
                        class: "regular grey",
                        scope: "global"
                      }, {
                        break: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], 512), [
        [_vShow, isSearchOpen.value]
      ])
    ], 2)
  ], 40, _hoisted_1)), [
    [_directive_click_outside, closeSearch]
  ])
}
}

})